import { inject, LOCALE_ID } from '@angular/core';

export const getLocale = () => {
  const locale = inject(LOCALE_ID);
  return locale;
};
